import { useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import { raceClassesObj } from '../../../utils/CheckEligibleRaceClasses';
import { validateYupSchema } from 'formik';

function RaceClassBulkDropdown({
  selectedElements,
  setRaceClassBulkInfo,
  raceClassBulkInfo,
  toggleBtnClasses,
  mobileMode,
  disabled = false,
}) {
  useEffect(() => {
    if (mobileMode) {
      setRaceClassBulkInfo({
        ...raceClassBulkInfo,
        raceClassItem: {
          name: 'Dam',
          value: 'Women',
        },
        selectedElements: selectedElements,
      });
    }
  }, [mobileMode]);

  const raceClassDropdownItems = Object.values(raceClassesObj).map((v) =>
    Object.assign({
      value: v.id,
      name: v.label,
    })
  );

  const onChangeRaceClass = (raceClassItem) => {
    setRaceClassBulkInfo({
      ...raceClassBulkInfo,
      modalShow: true,
      raceClassItem: raceClassItem,
      selectedElements: selectedElements,
    });
  };

  return (
    <>
      {mobileMode && <label className="fw-bold mb-1">Tävlingsklass</label>}
      <Dropdown>
        <Dropdown.Toggle
          variant="outline-primary"
          className={toggleBtnClasses}
          disabled={disabled}
        >
          {mobileMode
            ? raceClassBulkInfo?.raceClassItem?.name
            : 'Redigera tävlingsklass'}{' '}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {raceClassDropdownItems.map((rci) => (
            <Dropdown.Item
              key={rci.name}
              onClick={() => onChangeRaceClass(rci)}
            >
              {rci.name}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
}

export default RaceClassBulkDropdown;
